<template>
  <div class="detail-box">
    <span class="title">{{title}}</span>
    <span class="time">更新日期：{{time}}</span>

    <div v-if="fileUrl.indexOf('.pdf') > -1" class="iframe-box">
      <span class="black pdfHideBack"></span>
      <iframe v-if="fileUrl" class="file-iframe" :src="fileUrl" frameborder="0"></iframe>
    </div>
    <div class="content" v-html="htmlData">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: [String, Number]
  },
  data () {
    return {
      title: '',
      time: '',
      htmlData: '', // 富文本内容
      fileUrl: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getDetailById()
    },
    async getDetailById () {
      const res = await this.$https.getDetailById(this.id)
      this.title = res.data.data.title
      this.time = res.data.data.create_time_date
      if (res.data.data.attach) this.fileUrl = this.$baseUrl + res.data.data.attach
      this.htmlData = res.data.data.graphic
    }
  }
}
</script>

<style scoped lang="less">
  .iframe-box{
    width: 100%;
    position: relative;

    .black{
      position: absolute;
      top: 0px;
      right: 0px;
      width: 380px;
      height: calc(3.5vh + 25px);
      z-index: 10;
      background-color: #323639;
      user-select: none;
    }
  }
.file-iframe{
  width: 100%;
  height: 800px;
}
  .detail-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 20px;

    .title{
      font-family: PingFang;
      font-weight: bold;
      font-size: 20px;
      color: #0067D1;
      line-height: 26px;
      width: 100%;
      text-align: center;
    }

    .time{
      text-align: center;
      width: 100%;
      color: #999;
      font-size: 18px;
      margin-top: 28px;
      margin-bottom: 66px;
    }

    .content{
      width: 100%;
      overflow-x: auto;
      word-break: break-word;
    }
  }
</style>
